import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import config_panel_logo from "../images/config_panel_logo.png"
import feature_generation_logo from "../images/feature_engineering_logo.png"
import runways_logo from "../images/runways_logo.png"
import model_training_logo from "../images/model_training_logo.png"
import { GreenSpinner } from "../style/header_styles";
import {
    Heading,
    Body,
    WelcomeBanner,
    FeatureGenerationButton,
    MLTrainingBox,
    RunwaysButton,
    ExperimentsButton,
    ConfigPanelButton,
    LearnMoreLink,
    MainWrapper,
    SubWrapper
} from "../style/home_styles";
import {FLOWS, isAnchor} from "src/utils/url_utils";
import {isEmpty} from "src/utils/common_utils";
import {showSnackBar} from "src/control/actions/commons/snack_bar_actions";
import {CONFIG_PANEL_USER_GUIDE, FEATURE_GENERATION_USER_GUIDE, MODEL_TRAINING_USER_GUIDE} from "src/external_links";


export default function Home() {
    const history = useHistory();
    const dispatch = useDispatch();
    let selectedTeam = useSelector((state:any) => state.team.team)

    const reRouteToNamespace = (event: any, flow: string) => {
        if(isEmpty(selectedTeam)) {
            dispatch(showSnackBar("Please select team to continue"));
        }
        if (!isAnchor(event) && !isEmpty(selectedTeam)) {
            history.push(`/${flow}/${selectedTeam.teamId}/namespaces`);
        }
    }

    const getWelcomeBanner = () => {
        let username = useSelector((state:any) => state.user.username);

        if (!username) {
            return <GreenSpinner variant={"default"} size={"small"}/>
        }

        return (
            <WelcomeBanner
                header = {"Welcome " + username.toUpperCase() + ", What would you like to do today?"}
                description = {"Please choose team to continue"}
                persistent
            />
        )

    }

    return (
        <MainWrapper>
            <SubWrapper>
                {getWelcomeBanner()}
            </SubWrapper>
            <SubWrapper>
                <FeatureGenerationButton
                    variant={"link"}
                    onClick={(e: any)=>{reRouteToNamespace(e, FLOWS.FEATURE_GENERATION);}}
                >
                    <img className={"flow-logo"} src={feature_generation_logo} alt={"FeatureGeneration"}/>
                    <Heading>
                        Feature Generation
                    </Heading>
                    <Body>
                        Generate nearly static and/or realtime streaming features
                        over live production traffic in a sandboxed environment
                    </Body>
                    <LearnMoreLink href={FEATURE_GENERATION_USER_GUIDE} target="_blank" rel="noopener noreferrer">
                        learn more
                    </LearnMoreLink>
                </FeatureGenerationButton>
            </SubWrapper>
            <SubWrapper>
                <MLTrainingBox onClick={(event:any) => {reRouteToNamespace(event, FLOWS.MODEL_TRAINING)}}>
                    <RunwaysButton
                        variant={"link"}
                        onClick={(e: any)=> {}}
                    >
                        <img className={"flow-logo"} src={runways_logo} alt={"Runways"}/>
                        <Heading>
                            Runways
                        </Heading>
                        <Body>
                            Create ML training workflows with support for EMR based
                            data processing jobs.
                        </Body>
                        <LearnMoreLink href={MODEL_TRAINING_USER_GUIDE} target="_blank" rel="noopener noreferrer">
                            learn more
                        </LearnMoreLink>
                    </RunwaysButton>
                    <Heading style={
                        {
                            padding: "10px",
                            verticalAlign:"bottom",
                            display:"table-cell"
                        }
                    }>
                        ML Training
                    </Heading>
                    <ExperimentsButton
                        variant={"link"}
                        onClick={(e: any)=> {}}
                    >
                        <img className={"flow-logo"} src={model_training_logo} alt={"ModelTraining"}/>
                        <Heading>
                            Experiments
                        </Heading>
                        <Body>
                            Create experiments over existing ML workflows or build an experiment
                            from scratch using sagemaker notebooks with support for managing code
                            and orchestration.
                        </Body>
                        <LearnMoreLink href={MODEL_TRAINING_USER_GUIDE} target="_blank" rel="noopener noreferrer">
                            learn more
                        </LearnMoreLink>
                    </ExperimentsButton>
                </MLTrainingBox>
            </SubWrapper>
            <SubWrapper>
                <ConfigPanelButton
                    variant={"link"}
                    onClick={(event: any)=>{
                        reRouteToNamespace(event, FLOWS.CONFIG_PANEL);
                    }}
                >
                    <img className={"flow-logo"} src={config_panel_logo} alt={"ConfigPanel"}/>
                    <Heading>
                        Configuration Panel
                    </Heading>
                    <Body>
                        Use the Expresso Live Config console to create/update application
                        configurations in near realtime without any deployment
                    </Body>
                    <LearnMoreLink href={CONFIG_PANEL_USER_GUIDE} target="_blank" rel="noopener noreferrer" >
                        learn more
                    </LearnMoreLink>
                </ConfigPanelButton>
            </SubWrapper>
        </MainWrapper>
    )
}